import { component as defineComponent } from 'flightjs';

export default defineComponent(function () {

    this.after('initialize', function () {
        this.on(document, 'uiWatchNdaContestRequested', this.loadNdaModalContent);
        this.on(document, 'uiSignNdaRequested', this.signNda);
    });

    this.loadNdaModalContent = function (e, data) {
        var listingId = data.listingId;
        var contentUrl = data.contentUrl;
        var acceptUrl = data.acceptUrl;
        var xhr = $.get(contentUrl);

        xhr.done(function (res) {
            this.trigger('dataNdaLoaded', {listingId: listingId, content: res, acceptUrl: acceptUrl});
        }.bind(this));
    };

    this.signNda = function (e, data) {
        var url = data.url;
        var listingId = data.listingId;

        var xhr = $.post(url, {
            agreeToCustomNda: data.agreeToCustomNda
        });

        xhr.done(function (res) {
            this.trigger('dataNdaSigned', {listingId: listingId});
        }.bind(this));
        xhr.error(function (res) {
            this.trigger('dataNdaSigningFailed', {listingId: listingId});
        }.bind(this));
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/data/nda.js